export enum RotatedGridWithElementsBlock {
  Root = 'RotatedGridWithElements',
}

export enum RotatedGridWithElementsElement {
  Title = 'title',
  Grid = 'grid',
}
